import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import { StampCardRow } from '@models/stamp';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    stampCard: StampCardRow;
}

function StampImages({ stampCard }:Props) {
    const { t } = useTranslation('stamp');
    const {
        stampExpiredDays, stampCount, totalSlots,
    } = stampCard;
    const [expireIndex, setExpireIndex] = useState<number>(-1);
    const { stampImage, stampDefaultImage } = useAppCustom().membership;
    return (
        <Container >
            {Array.from({ length: totalSlots }).map((_, value) => {
                const stampIcon = (() => {
                    const active = value < stampCount;
                    if (active) {
                        if (stampImage) {
                            return (
                                <CircleImage width={38}
                                    height={38}
                                    src={stampImage}/>
                            );
                        }
                        return (<DefaultStamp isChecked/>);
                    }
                    if (stampDefaultImage) {
                        return (
                            <CircleImage width={38} height={38} src={stampDefaultImage}/>
                        );
                    }
                    return <DefaultStamp />;
                })();
                const dateStr = stampExpiredDays?.[value];
                const leftDays = dateStr ? dayjs(dateStr)
                    .diff(dayjs().set('hour', 0).set('minute', 0).set('second', 0), 'days') + 1 : undefined;
                return (
                    <StampWrapper key={value.toString()}
                        align='center'
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setExpireIndex(value);
                        }} >
                        {stampIcon}
                        {(expireIndex === value && value < stampCount) && (
                            <ExpiredWrapper>
                                <Text size='s'
                                    fontWeight='bold'
                                    color={colors.white}>
                                    {leftDays}{t('card.daysUnit')}
                                </Text>
                            </ExpiredWrapper>
                        )}
                    </StampWrapper>
                );
            })}
        </Container>
    );
}

const Container = styled.div`
    background:  var(--color-gray6);
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 20px 24px;
    row-gap: 16px;
    justify-content: flex-end;
    border-radius: 0 8px 0 8px;
`;

const CircleImage = styled(Image)`
    border-radius: 50%;
`;

const DefaultStamp = styled.div<{
    isChecked?: boolean;
}>`
    aspect-ratio: 1;
    background-color: ${({ isChecked }) => (isChecked
        ? 'var(--color-primary)' : 'var(--color-gray1)')} ;
    border-radius: 50%;
    max-width: 38px;
    width: 100%;
    border:  ${({ isChecked }) => (isChecked
        ? '2px solid var(--color-white)' : 'none')};
`;

const ExpiredWrapper = styled.div`
    background-color: var(--color-gray9);
    padding: 0 6px;
    position: absolute;
    transform: translateX(19px) translateY(-6px);
`;

const StampWrapper = styled(Column)`
    position: relative;
    width: 25%;
    max-width: 25%;
    min-width: 25%;
`;

export default StampImages;
